import React from 'react';
import { DollarSign, Heart, Zap, TrendingUp } from 'lucide-react';
import { whyChooseUs } from '../mock';

const iconMap = {
  0: DollarSign,
  1: Heart,
  2: Zap,
  3: TrendingUp
};

const WhyChooseUs = () => {
  return (
    <section className="py-32 bg-black relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-20 left-20 w-96 h-96 bg-brand-yellow/10 rounded-full blur-3xl animate-pulse-slow"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-brand-olive/10 rounded-full blur-3xl animate-pulse-slow" style={{ animationDelay: '1s' }}></div>
      </div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Section header */}
          <div className="text-center mb-20">
            <h2 className="text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight">
              Why Choose JRT Chideme Media?
            </h2>
            <p className="text-xl lg:text-2xl text-white/80 max-w-3xl mx-auto font-light">
              We're not just another agency. We're your partner in digital success, 
              committed to making professional marketing accessible to everyone.
            </p>
          </div>
          
          {/* Features grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {whyChooseUs.map((item, index) => {
              const Icon = iconMap[index];
              return (
                <div 
                  key={item.id}
                  className="text-center group"
                >
                  <div className="mb-6 flex justify-center">
                    <div className="w-20 h-20 bg-brand-olive/20 rounded-2xl flex items-center justify-center group-hover:bg-brand-yellow group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                      <Icon className="w-10 h-10 text-brand-yellow group-hover:text-brand-brown transition-colors duration-300" />
                    </div>
                  </div>
                  <h3 className="text-xl font-bold mb-3">
                    {item.title}
                  </h3>
                  <p className="text-white/70 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              );
            })}
          </div>
          
          {/* Stats section */}
          <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 pt-12 border-t border-white/20">
            <div className="text-center">
              <div className="text-4xl font-bold text-brand-yellow mb-2">10-30%</div>
              <div className="text-sm text-white/70">Monthly Revenue Growth</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-brand-yellow mb-2">70-80%</div>
              <div className="text-sm text-white/70">Profit Margins</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-brand-yellow mb-2">UK-Based</div>
              <div className="text-sm text-white/70">Local Expertise</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-brand-yellow mb-2">AI-Powered</div>
              <div className="text-sm text-white/70">Cutting-Edge Tools</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
